import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

export default function GoRedirectHandler() {
  const { code } = useParams();
  const history = useHistory();

  useEffect(() => {
    const go = async () => {
      try {
        const res = await fetch(`https://r0hzfyhxlb.execute-api.us-east-1.amazonaws.com/prod/go/${code}`);
        if (!res.ok) throw new Error("Not found");
        const data = await res.json();

        const params = new URLSearchParams({
          user_id: data.user_id,
          event: data.event_id,
          eventName: data.event_name
        });

        history.replace(`/UploadImages?${params.toString()}`, {
          eventData: {
            event_id: data.event_id,
            username: data.user_id,
            user_id: data.user_id,
            event_name: data.event_name,
            event_date: data.event_date,
            event_location: data.event_location,
            guest_link: `https://r0hzfyhxlb.execute-api.us-east-1.amazonaws.com/prod/go/${code}`
          }
        });
      } catch (err) {
        alert("קישור לא תקין או שפג תוקפו.");
        history.replace("/");
      }
    };

    go();
  }, [code, history]);

  return <div>טוען…</div>;
}
